import MenuIntegracoes from "../MenuIntegracoes";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PesquisaArtigo from "../PesquisaArtigo";

export default function Integracao() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);
  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/integracoes">Integrações</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Solução de problemas - Conta de Anúncio
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuIntegracoes />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">
                Solução de problemas - Conta de Anúncio
              </h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Integrações</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Conecte sua rede social
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  Certifique-se que a sua conta de anúncio está configurada
                  corretamente e pertencente a conta empresarial selecionada na
                  criação da campanha.
                </p>

                <p>
                  Caso o Facebook tenha algum problema relacionado a sua conta
                  de anúncio, a seguinte mensagem será exibida:
                </p>

                <figure>
                  <img src="img/erros-businessaccount.png" alt="excel" />
                </figure>

                <figcaption>Erro Conta de Anúncio</figcaption>

                <p>
                  Verifique no seu gerenciador de anúncios da Meta e na criação
                  da campanha, se a sua conta de anúncios está vinculado
                  corretamente a uma empresa, caso apareça esta tela da imagem,
                  você precisa adicionar a uma empresa e após vincular
                  corretamente, realizar novamente a campanha na Sales Box.
                </p>

                <figure>
                  <img src="img/error-bussinessaccount.png" alt="excel" />
                </figure>

                <figcaption>Adicionando conta a uma empresa</figcaption>

                <p>
                  Veja as{" "}
                  <a
                    href="https://www.facebook.com/business/help/910137316041095?id=420299598837059"
                    target="Blank"
                  >
                    instruções do Facebook
                  </a>{" "}
                  para adicionar contas de anúncios no gerenciador de negócios.
                </p>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>
      </section>

      {showScrollButton && (
        <a onClick={scrollToTop} className="btn-topo">
          <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
        </a>
      )}

      <Footer />
    </>
  );
}
